export {default} from './Image'
